<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />
    
    <div style="width: 1200px; margin: auto;     padding-bottom: 10%; overflow: hidden;">
<userLeft :active="11" />
      <div class="box5">
        <div style="overflow: hidden;">
          <div class="box6" style="float: left;">设置支付密码</div>
        </div>
        <div class="box7"></div>

        <div style="width: 50%; margin: 4% auto;">
            <div>
              <div class="step" style="position: relative;">1
                <div class="line_bottom_txt">身份验证</div>
              </div>

          <div class="step_line"></div>
          <div class="step_line" style="background: #EBE5EE;"></div>
          <div class="step" style="position: relative;">2
            <div class="line_bottom_txt">设置支付密码</div>
          </div>
          <div class="step_line"></div>
          <div class="step_line" style="background: #EBE5EE;"></div>
          <div class="step" style="position: relative;">3
            <div class="line_bottom_txt" style="left: -60px;">完成</div>
          </div>
          </div>
          <div style="width: 100%; height: 50px;"></div>
          <div class="tips_txt" style="margin-top: 60px;">已绑定的手机：138****0000</div>
          <div style="text-align: center; margin-top: 4%;">
            <!-- <a-input-search
            placeholder="input search text"
            enter-button="Search"
            size="large"
            @search="onSearch"
          /> -->

          <div style="overflow: hidden;width: 340px; height: 48px;margin: 30px auto;">
            <div class="yzm_but">获取验证码</div>
            <input type="text" class="input" style="width: 60%;" name="" placeholder="手机号码"  id="">
        </div>

          <div style="text-align: center;">
            <a-button type="primary"  style="width: 100px; height: 40px; background: #2B9A34; border: none; margin-top: 4%;">
              下一步
            </a-button>
          </div>

          

          </div>
          
        </div>
        <div style="width: 100%;height: 1px;border: 1px dashed #EEEEEE; margin-top: 4%;"></div>
        <div class="tips1">温馨提示</div>
        <div class="tips2" style="margin-top: 2%;">
          <div class="yuandian"></div>
          <span style="margin-left: 5px;">为保障您的账号安全，变更重要信息需要身份验证</span>
        </div>
        <div class="tips2" style="margin-top: 2%;">
          <div class="yuandian"></div>
          <span style="margin-left: 5px;">为保障您的账号安全，变更重要信息需要身份验证</span>
        </div>
        <div class="tips2" style="margin-top: 2%;">
          <div class="yuandian"></div>
          <span style="margin-left: 5px;">为保障您的账号安全，变更重要信息需要身份验证</span>
        </div>

      </div>
    </div>
    <foot/>
  </div>
</template>

<script>
    import axios from "axios";
    import userLeft from "../public/user_left";
    import htmlHeader from "../public/head";
import foot from "../public/foot";
    export default {
        name: "integral",
          components: {
    userLeft,
        htmlHeader,
    foot,
  },
        data() {
            return {

            };
        },
        methods: {

        },
        created() {

        },
    };
</script>

<style scoped>
      .input {
        width: 80%; height: 100%;
        float: left;
        border: 1px solid #EDE9E9;
        display: block;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        padding-left: 10px;
        outline: none;
    }
          .yzm_but {
        width: 40%;
        height: 100%;
        float: right;

font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #fff;
background: #CCCCCC;
text-align: center;
line-height: 48px;
border-left: none;

    }
.line_bottom_txt {
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #333333;
line-height: 16px;
text-align: center;
margin-top: 10px;
position: absolute;
bottom: -30px;
left: -55px;
width: 150px;

}
  .yuandian {
    width: 6px;
          height: 6px;
          background: #666666;
          border-radius: 50%;
          float: left;
          margin-top: 5px;
          
  }
 .tips2 {
font-size: 12px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #666666;

  }
  .tips1 {
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #333333;
margin-top: 4%;
  }
  .tips_txt {
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #333333;
text-align: center;
margin-top: 4%;
  }
.step {
  width: 30px;
height: 30px;
background: #2B9A34;
border-radius: 50%;
float: left;
text-align: center;
line-height: 30px;
color: #fff;
font-size: 14px;
 
}

.step_line {
  width: 80px;
height: 6px;
background: #2B9A34;
opacity: 0.8;
margin-top: 12px;
/* margin-left: 30px; */
float: left;
}
    
    .box7 {
        width: 100%;
        height: 1px;
border-top: 1px solid #E8E6E6;        margin-top: 2%;
    }
    
    .box6 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        /* margin-top: 2%; */
        text-align: left;
    }
    
.box5 {
        min-height: 1023px;
        width: 80%;
        min-height: 1023px;
        border: 1px solid #EDE9E9;
        float: right;
        margin-top: 2%;
        padding: 2%;
    }
    
    .box3 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: Regular;
        color: #666666;
        margin-top: 6%;
    }
    
    .box4 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }
    
    .box1 {
        width: 220px;
        min-height: 1023px;
        border: 1px solid #EDE9E9;
        float: left;
        margin-top: 2%;
    }
    
    .box2 {
        width: 100%;
        height: 45px;
        background: #F2F2F2;
    }
</style>


// WEBPACK FOOTER //
// src/components/reset_password.vue